@for (alert of alertsService.alertList; track alert) {
    <ngb-alert [type]="alert.type" [dismissible]="alert.dismissable || true" (closed)="alertsService.close(alert)">{{ alert.message }}</ngb-alert>
}
